import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {
    IArenaGameFiltersCategoryEditorViewModel
} from "../../../../services/games-filter/arena-filters/categories/arena-game-filters-category-editor-view-model.interface";
import {FilterCategoryContentBox} from "./boxes/filter-category-content.box";
import {observer} from "mobx-react";
import {FilterCategoryItemComponent} from "./filter-category-item.component";

interface FilterCategoryContentComponentProps {
    category: IArenaGameFiltersCategoryEditorViewModel;
    isOpen: boolean;
}


export const FilterCategoryContentComponent = observer(
    class FilterCategoryContentComponent extends OrbitComponent<FilterCategoryContentComponentProps> {

        _renderFilters(category: IArenaGameFiltersCategoryEditorViewModel) {


            return <>
                {category.visibleFilters.map(filterToRender => (<FilterCategoryItemComponent key={filterToRender.id}
                                                                                  filter={filterToRender}
                                                                                  inputType={category.isMultiSelect ? 'checkbox' : 'radio'}
                                                                                  filterCategoryId={category.id}/>))}
            </>;
        }

        render() {
            if(!this.props.isOpen) {
                return null;
            }

            return (
                <FilterCategoryContentBox>
                    {this._renderFilters(this.props.category)}
                </FilterCategoryContentBox>
            )
        }
    }
);